export const TOOLTIP_NAME = {
	LANGUAGE: 'language',
	USERNAV: 'usernav',
	PRIVATENAV: 'privatenav',
	COMPANYPROFILE: 'companyprofile',
	FEEDBACK: 'feedback',
	LOGOUT: 'logout',
	ACTION: 'action',
};

const defaults = {
	position: 'right',
	align: 'center',
	offset: 12,
	delayShow: 300,
	delayHide: 200,
	radius: 'sm',
	arrow: true,
};

export const tooltipConfig = {
	language: { ...defaults, offset: 12 },
	usernav: { ...defaults },
	privatenav: { ...defaults },
	companyprofile: { ...defaults },
	feedback: { ...defaults },
	logout: { ...defaults },
	action: { ...defaults },
};
